const UserMixin = {
  computed: {
    loginUser() {
      const loginUser = this.$store.getters['users/getLoginUser'];
      return loginUser.loginUser;
    },
    loginUserName() {
      if (this.loginUser.company_name) {
        return `${this.loginUser.company_name} (${this.loginUser.name})`;
      } else {
        return this.loginUser.name;
      }
    },
    loginUserNextPage() {
      const loginUser = this.$store.getters['users/getLoginUser'];
      return loginUser.nextPage;
    },
    loginEmail() {
      const loginUser = this.$store.getters['users/getLoginUser'];
      return loginUser.loginEmail;
    },
    loginUserStatus() {
      const loginUserStatus = this.$store.getters['users/getLoginUser'];
      return loginUserStatus;
    },
    loginUserRole() {
      const loginUser = this.$store.getters['users/getLoginUser'];
      return loginUser.loginUserRole;
    },
    isLoggedIn() {
      const loginUser = this.$store.getters['users/getLoginUser'];
      return loginUser.isLogin;
    },
    impersonation() {
      const impersonation = this.$store.getters['users/manager/getImpersonation'];
      return impersonation;
    },
    impersonationUser() {
      const impersonation = this.$store.getters['users/manager/getImpersonation'];
      if (impersonation.impersonateRole == 'consumer') {
        return impersonation.consumer;
      } else {
        return impersonation.provider;
      }
    },
    isImpersonated() {
      const impersonation = this.$store.getters['users/manager/getImpersonation'];
      return impersonation.impersonate;
    },
    impersonatedRole() {
      const impersonation = this.$store.getters['users/manager/getImpersonation'];
      return impersonation.impersonateRole;
    },
    impersonationManager() {
      const loginUser = this.$store.getters['users/getLoginUser'];
      return loginUser;
    },
    impersonatedUserName() {
      if (!this.isImpersonated) {
        return null;
      }

      const impersonated = this.impersonationUser;

      if (impersonated.company_name) {
        return `(${impersonated.company_name} ${impersonated.last_name} ${impersonated.first_name}様)`;
      } else {
        return `(${impersonated.last_name} ${impersonated.first_name}様)`;
      }
    },
    createProviderFlag() {
      const provider = this.$store.getters['users/provider/getProvider'];
      return provider.createProviderFlag;
    },
  },
  methods: {
    async impersonatedLogin(role, userId, redirectUrl = '/movies') {
      if (role === 'consumer') {
        await this.$store.dispatch('users/manager/impersonationCustomer', {
          customerId: userId,
          redirectPath: redirectUrl,
        });
      } else if (role === 'provider') {
        await this.$store.dispatch('users/manager/impersonationProvider', {
          providerId: userId,
          redirectPath: redirectUrl,
        });
      } else {
        console.log('unknown type of user to impersonate');
      }
    },
    impersonatedLogout(redirectUrl = '/admin/quotes') {
      this.$store.dispatch('users/manager/logoutImpersonation', {
        userType: this.impersonatedRole,
        redirectPath: redirectUrl,
      });
    },
    resetCreateProviderFlag() {
      this.$store.dispatch('users/provider/removeCreateProviderFlag');
    },
  },
};

export default UserMixin;
